import React from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import {
  getHoursMinutes,
  convertTimestampMD,
} from '../helpers/misc';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  authorizedModules: state.main.authorizedModules,
});

const Stoppage = props => {
  const {
    scheduleObj,
    colorScheme,
    isLast,
    removeStoppage,
    authorizedModules,
  } = props;
  
  const handleDeleteStoppageClick = () => {
    if(window.confirm('Are you sure you want to remove this stoppage from the schedule?'))
      removeStoppage();
  };
  
  return (
    <div
      style={{
        ...styles.container,
        borderColor: GLOBAL_STYLES[colorScheme].fgColor,
        marginBottom: isLast ? 20 : 0,
        backgroundColor: scheduleObj.isGenerated ?
          GLOBAL_STYLES.CONSTANTS.lightGray :
          GLOBAL_STYLES.CONSTANTS.blueColor,
      }}
    >
      <div style={styles.textContainer}>
        <p style={styles.text}>
          <span style={styles.title}>
            {scheduleObj.stoppageReason}
          </span>
        </p>
        <p style={styles.text}>
          <span style={styles.title}>
            {`RUNTIME: `}
          </span>
          {getHoursMinutes(scheduleObj.endTime - scheduleObj.startTime)}
        </p>
        <p style={styles.text}>
          <span style={styles.title}>
            {`START: `}
          </span>
          {convertTimestampMD(scheduleObj.startTime)}
        </p>
        <p style={styles.text}>
          <span style={styles.title}>
            {`END: `}
          </span>
          {convertTimestampMD(scheduleObj.endTime)}
        </p>
      </div>
      {
        !scheduleObj.isGenerated && !scheduleObj.isChangeover && !authorizedModules.includes('READ_ONLY') ?
          <div style={styles.buttonContainer}>
            <i
              className={`fa fa-trash fa-2x toolbar-button`}
              style={styles.trashButton}
              onClick={handleDeleteStoppageClick}
            />
          </div> :
          null
      }
    </div>
  );
};

const styles = {
  container: {
    userSelect: 'none',
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  title: {
    fontWeight: 'bold',
  },
  text: {
    margin: 0,
    padding: 0,
  },
  textContainer: {
    flex: 1,
    paddingRight: 10,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  trashButton: {
    cursor: 'pointer',
  },
};

export default connect(mapStateToProps)(Stoppage);